import React, { useEffect, useState } from 'react'

const Transfer = ({ active }) => {
    const [primaryColor, setPrimaryColor] = useState(active ? "#fff" : (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim())
    useEffect(() => {
        setPrimaryColor(active ? "#fff" : (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim())
        
    }, [active])
    return (
        <svg width="22" height="22" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 15.1C10 16.264 10.9 17.2 12.004 17.2H14.26C15.22 17.2 16 16.384 16 15.364C16 14.272 15.52 13.876 14.812 13.624L11.2 12.364C10.492 12.112 10.012 11.728 10.012 10.624C10.012 9.61599 10.792 8.78799 11.752 8.78799H14.008C15.112 8.78799 16.012 9.72399 16.012 10.888" stroke={primaryColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill='none' />
            <path d="M13 7.60001V18.4" stroke={primaryColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill='none' />
            <path d="M25 13C25 19.624 19.624 25 13 25C6.376 25 1 19.624 1 13C1 6.376 6.376 1 13 1" stroke={primaryColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill='none' />
            <path d="M25.0002 5.8V1H20.2002" stroke={primaryColor} fill='none' stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M19 7L25 1" stroke={primaryColor} fill='none' stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export default Transfer